import "./RatingStars.css";

const RatingStars = () => {
  return (
    <div className="stars">
      <input
        className="stars__checkbox"
        type="radio"
        id="first-star"
        name="star"
      />
      <label className="stars__star" htmlFor="first-star">
        <svg
          className="stars__star-icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 53.867 53.867"
          style={{ enableBackground: "new 0 0 53.867 53.867" }}
          xmlSpace="preserve"
        >
          <polygon
            points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                                                                                    10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
          />
        </svg>
      </label>
      <input
        className="stars__checkbox"
        type="radio"
        id="second-star"
        name="star"
      />
      <label className="stars__star" htmlFor="second-star">
        <svg
          className="stars__star-icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 53.867 53.867"
          style={{ enableBackground: "new 0 0 53.867 53.867" }}
          xmlSpace="preserve"
        >
          <polygon
            points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                                                                                    10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
          />
        </svg>
      </label>
      <input
        className="stars__checkbox"
        type="radio"
        id="third-star"
        name="star"
      />
      <label className="stars__star" htmlFor="third-star">
        <svg
          className="stars__star-icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 53.867 53.867"
          style={{ enableBackground: "new 0 0 53.867 53.867" }}
          xmlSpace="preserve"
        >
          <polygon
            points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                                                                                    10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
          />
        </svg>
      </label>
      <input
        className="stars__checkbox"
        type="radio"
        id="fourth-star"
        name="star"
      />
      <label className="stars__star" htmlFor="fourth-star">
        <svg
          className="stars__star-icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 53.867 53.867"
          style={{ enableBackground: "new 0 0 53.867 53.867" }}
          xmlSpace="preserve"
        >
          <polygon
            points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                                                                                    10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
          />
        </svg>
      </label>
      <input
        className="stars__checkbox"
        type="radio"
        id="fifth-star"
        name="star"
      />
      <label className="stars__star" htmlFor="fifth-star">
        <svg
          className="stars__star-icon"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 53.867 53.867"
          style={{ enableBackground: "new 0 0 53.867 53.867" }}
          xmlSpace="preserve"
        >
          <polygon
            points="26.934,1.318 35.256,18.182 53.867,20.887 40.4,34.013 43.579,52.549 26.934,43.798 
                                                                                    10.288,52.549 13.467,34.013 0,20.887 18.611,18.182 "
          />
        </svg>
      </label>
    </div>
  );
};
export default RatingStars;
